import { Observable } from 'rxjs/Observable';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageSingleComponent } from "./pages/page-single/page-single.component";
import { PageHomeComponent } from "./pages/page-home/page-home.component";

import { ActivatedRouteSnapshot, RouteReuseStrategy, DetachedRouteHandle } from '@angular/router';

import {CanDeactivate, RouterStateSnapshot} from "@angular/router";

export class AnimationGuard implements CanDeactivate<PageSingleComponent> {
    canDeactivate(component:PageSingleComponent,
                  route:ActivatedRouteSnapshot,
                  state:RouterStateSnapshot):Observable<boolean> {
        console.log("AnimationGuard");
        console.log(route.params);
        console.log(state.url);
        return component.canDeactivate();
    }
}

const routes:Routes = [

    {
        path: ':slug',
        component: PageSingleComponent,
        canDeactivate: [AnimationGuard]
    },
    {
        path: '',
        component: PageHomeComponent,
        pathMatch: 'full',
    },
    // {
    //     path: "**",
    //     redirectTo: ''
    // }

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: []
})
export class Wpng2RoutingModule {
}

export class CustomReuseStrategy implements RouteReuseStrategy {

    shouldDetach(route:ActivatedRouteSnapshot):boolean {
        return false;
    }

    store(route:ActivatedRouteSnapshot, handle:DetachedRouteHandle):boolean {
        return false;
    }

    shouldAttach(route:ActivatedRouteSnapshot):boolean {
        return false;
    }

    retrieve(route:ActivatedRouteSnapshot):DetachedRouteHandle {
        return false;
    }

    shouldReuseRoute(future:ActivatedRouteSnapshot, curr:ActivatedRouteSnapshot):boolean {
        return false;
    }

}




// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts